<!-- <template>
	<div class="module_container full" style="position: relative;">
		<vxe-grid v-bind="gridOptions" :key="gridKey" v-if="gridOptions" @toolbar-button-click="toolbarButtonClickEvent"
			:ref="moduleName+'_list'">

		</vxe-grid>

		<formwindow :formConfig="formModule" v-if="formwindowShow" @back="formBack" />
	</div>
</template>
<style>

</style>
<style scoped>

</style> -->
<script>
	import listBase from '@_system/components/base/list.vue'

	export default {
		extends: listBase,
		name: 'wlnorderIndex',
		props: {

		},
		data() {
			return {
				moduleName: 'wlnorder',
				windowName: '万里牛订单',
				windowType:'modal'
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			// add() {
			// 	import('@/components/forms/wlnorder/form.vue').then((res) => {
			// 		this.formModule = {
			// 			component: res.default,
			// 			name: 'wlnorder',
			// 			id: 0,
			// 			controlltype: 1,
			// 			show: true,
			// 		}
			// 	})
			// },
			// edit(row) {
			// 	import('@/components/forms/wlnorder/form.vue').then((res) => {
			// 		this.formModule = {
			// 			component: res.default,
			// 			name: 'wlnorder',
			// 			id: row.id,
			// 			controlltype: 2,
			// 			show: true,
			// 		}
			// 	})
			// },
			// importMethod(e) {
			// 	if(e){
			// 		let file = e.file
			// 		let formData = new FormData()
			// 		formData.append('excle', file)
			// 		return new Promise((resolve) => {
			// 			this.$api[this.moduleName].import(formData).then((res) => {
			// 				if (res.errorData.length != 0) {
			// 					let message = ''
			// 					res.errorData.forEach((item) => {
			// 						message = message + item.goodscode + '：' + item.erro + '</br>'
			// 					})
			// 					this.$alert(message + '系统已忽略', res.errorData.length + '条数据错误', {
			// 						dangerouslyUseHTMLString: true
			// 					})
			// 				}else{
			// 					this.$message.success('操作成功')
			// 				}
			// 				this.customreload()
			// 				resolve()
			// 			}, (e) => {
			// 				this.$message.error(e)
			// 				resolve()
			// 			})
			// 		})
			// 	}
			// },
			// importtemplate(){
			// 	this.$store.commit('getTemplate','wlnorder')
			// }
		},
		components: {

		}
	}
</script>
